module.exports = "/dist/images/camera.png?36c030fd6614096776782c867eb11920";